import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import bgImg from './frame-bg.webp';

type ProgressCardProps = {
  progressPercent: number;
};

export const ProgressCard = ({ progressPercent }: ProgressCardProps) => {
  // Heading varies by completion: 0% → Get Started, 1–99% → Great Progress, 100% → Congratulations.
  const heading =
    progressPercent >= 100 ? 'Congratulations!' : progressPercent <= 0 ? 'Get Started!' : 'Great Progress!';

  return (
    <Box
      sx={{
        p: '16px',
        borderRadius: '15px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '59px',
        backgroundImage: `url(${bgImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontFamily: '"Fraunces", sans-serif !important',
          fontWeight: 'bold',
          mb: 0.25,
          fontSize: '12px',
          color: theme => theme.palette.common.black,
        }}
      >
        {heading}
      </Typography>
      <Typography
        variant="body2"
        sx={{ fontSize: '12px', fontWeight: 'normal', color: theme => theme.palette.common.black }}
      >
        You completed{' '}
        <Typography
          component="span"
          sx={{
            fontWeight: 'bold',
            fontSize: '12px !important',
            color: theme => theme.palette.primary.main,
          }}
        >
          {progressPercent}%
        </Typography>{' '}
        of the lesson!
      </Typography>
    </Box>
  );
};
